import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete, FormControlLabel, Checkbox } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { CurrencySymbol } from '../../../Utility/Constants'
import { AddCircle } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs';
import Loader from '../../../Components/Loader'
import { CheckAccessFunc, debounce } from '../../../Components/CommonFunctions/CommonFunctions'


const fieldLimits = {
    serviceCharge: 10,
    doctorShareRupee: 10,
    doctorSharePercent: 10,
    hospitalShareRupee: 10,
    hospitalSharePercent: 10,
};

const charge_type_category = ['Holiday', 'Emergency']

export default function HospitalEmergencyConfig() {
    let commonDisable = CheckAccessFunc("front_office", "Settings", "Service Master Configuration", "Holiday/Emergency", "SubTab")?.editAccess
    const [EmergHoliData, setEmergHoliData] = useState([]);
    const [searchList, setSearchList] = useState([]);
    const [serviceSearch, setserviceSearch] = useState('');
    const [formState, setFormState] = useState({
        serviceSearchData: null,
        departmentType: '',
        serviceHeadCode: '',
        serviceHead: '',
        serviceName: '',
        serviceCode: '',
        activeByHead: '',
        activeByName: '',
        patientType: '',
        editUnit: '',
        editAmount: '',
        editDiscount: '',
        selectedDoctorId: null,
        chargeType: 'Holiday',
        serviceCharge: '',
        doctorShareRupee: '',
        doctorSharePercent: '',
        hospitalShareRupee: '',
        hospitalSharePercent: '',
        startTime: null,
        endTime: null,
    });
    const [doctorList, setdoctorList] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [EditID, setEditID] = useState(null);
    const [isloader, setisloader] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [disableDoctor, setDisableDoctor] = useState(false);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    useEffect(() => {
        getDoctorList();
        getHolidayEmergData();
    }, [])

    useEffect(() => {
        if (serviceSearch?.length > 0) {
            getSearchData();
        }
    }, [serviceSearch])

    const debouncedSearch = useCallback(
        debounce((value) => {
            setserviceSearch(value);
        }, 500),
        []
    );

    const getHolidayEmergData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.NEW_DEPARTMENT_MASTER + `?charge_type=Holiday,Emergency`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setEmergHoliData(response.data.data || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getDoctorList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const doctorData = response.data.data || [];
                        const updatedDoctorList = [{ doctor_id: null, doctor_name: 'All' }, ...doctorData];
                        setDisableDoctor(true) // temp work
                        setdoctorList(updatedDoctorList);
                        setFormState((prevState) => ({
                            ...prevState,
                            selectedDoctorId: updatedDoctorList[0],
                        }));
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getSearchData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.CONFIGURATION_SERVICE_SEARCH + `?search_key=${serviceSearch}&module_type=${'OP'}&show_doc=true`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const result = response.data.data || [];
                        const filteredData = result.filter(item => item.active_by_service_head && item.active_by_service_name);
                        setSearchList(filteredData || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const onChangeAuto = (e, val, name) => {        
        switch (name) {
            case 'serviceSearchData':
                setFormState((prevState) => ({
                    ...prevState,
                    "serviceSearchData": val,
                    'departmentType': val?.module_type,
                    'serviceHeadCode': val?.service_head_code,
                    'serviceHead': val?.service_head_name,
                    'serviceName': val?.service_name,
                    'serviceCode': val?.service_code,
                    'patientType': val?.patient_type,
                    'activeByHead': val?.active_by_service_name,
                    'activeByName': val?.active_by_service_head,
                    'editUnit': val?.edit_unit,
                    'editAmount': val?.edit_amount,
                    'editDiscount': val?.edit_discount,
                }));
                if (!val?.doctor) { // temp work
                    setDisableDoctor(true)
                    getDoctorList()
                }
                if (val?.doctor && val?.doctor?.length > 0) {
                    setDisableDoctor(false) // temp work
                    setdoctorList(val?.doctor)
                    setFormState((prevState) => ({ ...prevState, "selectedDoctorId": val?.doctor[0] }));
                }
                break
            case 'selectedDoctorId':
                setFormState((prevState) => ({ ...prevState, "selectedDoctorId": val }));
                break
            case 'chargeType':
                setFormState((prevState) => ({ ...prevState, "chargeType": val }));
                break
        }
    }

    const [temp, setTemp] = useState({serviceCharge : '', doctorShareRupee : '', doctorSharePercent : '', hospitalShareRupee : '', hospitalSharePercent : ''  })

    const onChangeHandler = (e, name) => {
        let { value } = e.target;

        const isNumericField = [
            "serviceCharge",
            "doctorShareRupee",
            "doctorSharePercent",
            "hospitalShareRupee",
            "hospitalSharePercent"
        ].includes(name);

        if (isNumericField) {
            value = value.replace(/[^0-9 .]/g, "");  // Remove non-numeric characters execpt decimal point
            value = value.replace(/^0+/, "");        // Remove leading zeros
    
            // Prevent multiple decimals
            if ((value.match(/\./g) || []).length > 1) {
                return;
            }

            // Restrict decimal values to 2 digits
            if (value.includes(".")) {
                const [integer, decimal] = value.split(".");
                if (decimal.length > 2) {
                    return;  // Prevent typing more than 2 digits after decimal
                }
            }

            // Cap percentages at 100%
            if (name.includes("Percent")) {
                const numValue = parseFloat(value);
                if (!isNaN(numValue) && numValue > 100) {
                    value = "100";
                }
            }
        }

        // Update state with sanitized value
        let updatedState = { ...formState, [name]: value || "" };
        let updatedTemp = { ...temp, [name]: value || "" };

        const serviceCharge = parseFloat(updatedState.serviceCharge) || 0;

        updatedTemp.serviceCharge = serviceCharge // temp state for updating the accurate percentage values in temp
    
        if (name === "serviceCharge") {
            updatedState = {
                ...updatedState,
                doctorShareRupee: "",
                doctorSharePercent: "",
                hospitalShareRupee: "",
                hospitalSharePercent: ""
            };
    
            updatedTemp = {
                ...updatedTemp,
                doctorShareRupee: "",
                doctorSharePercent: "",
                hospitalShareRupee: "",
                hospitalSharePercent: ""
            };
        }

        if (serviceCharge > 0) {
            const doctorRupee = parseFloat(updatedState.doctorShareRupee) || 0;
            const hospitalRupee = parseFloat(updatedState.hospitalShareRupee) || 0;
            const doctorPercent = parseFloat(updatedState.doctorSharePercent) || 0;
            const hospitalPercent = parseFloat(updatedState.hospitalSharePercent) || 0;
            
            
            // Handle share recalculations dynamically
            if (name === "doctorShareRupee") {
                const doctorShare = Math.min(doctorRupee, serviceCharge);
                const doctorPercent = (doctorShare / serviceCharge) * 100;
                
                const hospitalShare = serviceCharge - doctorShare;
                const hospitalPercent = (hospitalShare / serviceCharge) * 100;

                // Temp states update for doc share
                updatedTemp.doctorShareRupee = doctorShare;
                updatedTemp.doctorSharePercent = doctorPercent;
                updatedTemp.hospitalShareRupee = hospitalShare;
                updatedTemp.hospitalSharePercent = hospitalPercent;
                
                updatedState.doctorShareRupee = value > serviceCharge ? serviceCharge : value
                updatedState.doctorSharePercent = (doctorPercent).toFixed(2)
                updatedState.hospitalShareRupee = (hospitalShare).toFixed(2)
                updatedState.hospitalSharePercent = (hospitalPercent).toFixed(2)
    
            } else if (name === "hospitalShareRupee") {
                const hospitalShare = Math.min(hospitalRupee, serviceCharge);
                const hospitalPercent = (hospitalShare / serviceCharge) * 100;
    
                const doctorShare = serviceCharge - hospitalShare;
                const doctorPercent = (doctorShare / serviceCharge) * 100;

                  // Temp states update for hos share 
                updatedTemp.hospitalShareRupee = hospitalShare;
                updatedTemp.hospitalSharePercent = hospitalPercent;
                updatedTemp.doctorShareRupee = doctorShare;
                updatedTemp.doctorSharePercent = doctorPercent;
    
                updatedState.hospitalShareRupee = value > serviceCharge ? serviceCharge : value
                updatedState.hospitalSharePercent = (hospitalPercent).toFixed(2)
                updatedState.doctorShareRupee = (doctorShare).toFixed(2)
                updatedState.doctorSharePercent = (doctorPercent).toFixed(2)
    
            } else if (name === "doctorSharePercent") {
                const docPercent = Math.min(parseFloat(value) || 0, 100);
                const doctorShare = (serviceCharge * docPercent) / 100;
    
                const hospitalShare = serviceCharge - doctorShare;
                const hospitalPercent = (hospitalShare / serviceCharge) * 100;

                  // Temp states update for doc percent
                updatedTemp.doctorShareRupee = doctorShare;
                updatedTemp.doctorSharePercent = docPercent;
                updatedTemp.hospitalShareRupee = hospitalShare;
                updatedTemp.hospitalSharePercent = hospitalPercent;
    
                updatedState.doctorShareRupee = (doctorShare).toFixed(2);
                updatedState.doctorSharePercent = value; 
                updatedState.hospitalShareRupee = (hospitalShare).toFixed(2);
                updatedState.hospitalSharePercent = (hospitalPercent).toFixed(2);
    
            } else if (name === "hospitalSharePercent") {
                const hospPercent = Math.min(parseFloat(value) || 0, 100);
                const hospitalShare = (serviceCharge * hospPercent) / 100;
    
                const doctorShare = serviceCharge - hospitalShare;
                const doctorPercent = (doctorShare / serviceCharge) * 100;

                  // Temp states update for hos percent
                updatedTemp.hospitalShareRupee = hospitalShare;
                updatedTemp.hospitalSharePercent = hospPercent;
                updatedTemp.doctorShareRupee = doctorShare;
                updatedTemp.doctorSharePercent = doctorPercent;
    
                updatedState.hospitalShareRupee = (hospitalShare).toFixed(2);
                updatedState.hospitalSharePercent = value;  
                updatedState.doctorShareRupee = (doctorShare).toFixed(2);
                updatedState.doctorSharePercent = (doctorPercent).toFixed(2);
            }
        }
        
        // Update both states
        setTemp(updatedTemp);
        setFormState(updatedState);
    };
    
    const textBox = (label, name, val, width, disable = false, Symbol = null) => {
        let IntValue = ["doctorShareRupee", "hospitalShareRupee", 'doctorSharePercent', 'hospitalSharePercent'].includes(name);        
    
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable || (IntValue && !formState.serviceCharge)}
                    value={val ? val : IntValue ? 0 : ""}
                    id="drug-master"
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    InputProps={Symbol ? {
                        style: { paddingRight: '0.5vw' },
                        endAdornment:
                            Symbol === 'rupee' ?
                                <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{CurrencySymbol}</Typography> :
                                Symbol === 'search' ?
                                    <Typography sx={{ fontSize: '0.9vw', pt: '0.5vw', pr: '0.2vw', fontWeight: 600 }} color={Colors.SecondaryText}>{<SearchIcon />}</Typography> :
                                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>%</Typography>

                    } : null}
                    onChange={(e) => { onChangeHandler(e, name) }}
                    variant="outlined"
                />
            </Box>
        )
    }

    const autoComplete = (label, name, val, list, width) => {
        return (
            <Box>
                <Autocomplete
                    size={'small'}
                    options={list}
                    name={name}
                    disabled={formState?.serviceSearchData?.service_charge_id  || name === 'selectedDoctorId' ? disableDoctor : null} // temp work
                    getOptionLabel={(option) =>
                        label === 'Doctor'
                            ? option?.doctor_name === 'None'
                                ? 'All'
                                : option?.doctor_name
                            : name === 'serviceSearchData'
                                ? `${option?.service_head_name || option?.service_head} ${option?.service_head_code ? `(${option?.service_head_code})` : ''} - ${option?.service_name} ${option?.service_code ? `(${option?.service_code})` : ''}`
                                : option
                    }
                    value={val}
                    onInputChange={(e, newInputValue) => {
                        if (name === 'serviceSearchData') {
                            if (newInputValue === "") {
                                // Clear related fields when the input is cleared
                                clearFunction()
                                getDoctorList()
                                setdoctorList([]);
                                setDisableDoctor(true);  // Reset doctor dropdown // temp work
                            } else {
                                debouncedSearch(newInputValue);  // Perform search only if input isn't cleared
                            }
                        }
                    }}
                    
                    onChange={(event, newValue) => {
                        onChangeAuto(event, newValue, name);
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            disabled={formState?.serviceSearchData?.service_charge_id  || name === 'selectedDoctorId' ? disableDoctor : null} // temp work
                            sx={{ width: width, marginRight: '0.3vw' }}
                        />
                    )}
                />
            </Box>
        );
    };


    const tableView = () => {
        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = EmergHoliData.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item?.service_charge_id)
            })
            setdelIDs(FinalData)
        }

        EmergHoliData?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'sno', headerName: 'S.No', flex: 0.02, sortable: false,
                renderCell: (params) => (<Typography fontSize={'0.9vw'}>{params.row.sno}</Typography>)
            },
            {
                field: 'service_head', headerName: 'Service Head Details', flex: 0.19,
                renderCell: (params) => (params.row.service_head ? params.row.service_head?.length > 25 || params.row.service_head_code?.length > 10 ?
                    <Tooltip placement="top" title={`${params.row.service_head_code ? params.row.service_head_code + ' - ' : ''}${params.row.service_head}`}><Typography fontSize={'0.9vw'}>{params.row.service_head_code ? params.row.service_head_code + ' - ' : ''}{params.row.service_head.slice(0, 22) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.service_head_code ? params.row.service_head_code + ' - ' : ''}{params.row.service_head}</Typography> : '-')
            },
            {
                field: 'service_name', headerName: 'Service Name Details', flex: 0.19,
                renderCell: (params) => (params.row.service_name ? params.row.service_name?.length > 25 || params.row.service_code?.length > 10 ?
                    <Tooltip placement="top" title={`${params.row.service_code ? params.row.service_code + ' - ' : ''}${params.row.service_name}`}><Typography fontSize={'0.9vw'}>{params.row.service_code ? params.row.service_code + ' - ' : ''}{params.row.service_name.slice(0, 22) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.service_code ? params.row.service_code + ' - ' : ''}{params.row.service_name}</Typography> : '-')
            },
            {
                field: 'charge_type', headerName: 'Charge Type', flex: 0.12,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.charge_type ? params?.row?.charge_type : '-'}</Box>)

            },
            {
                field: 'service_charge', headerName: 'Charge', flex: 0.12,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.service_charge ? params?.row?.service_charge : '-'}</Box>)

            },
            {
                field: 'doctor_share_amount', headerName: 'Doctor Share', flex: 0.11,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.doctor_share_amount ? params?.row?.doctor_share_amount : 0}</Box>)
            },
            {
                field: 'hospital_share_amount', headerName: 'Hospital Share', flex: 0.11,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.hospital_share_amount ? params?.row?.hospital_share_amount : 0}</Box>)
            },
            ...(commonDisable ? [
                {
                    field: 'action', headerName: 'Action', flex: 0.1,
                    renderCell: (params) => (
                        <Stack direction="row" alignItems="center" spacing={4}>
                            <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                                <CommonEditButton size="1.5vw" onClick={() => {
                                    let data = params.row
                                    setFormState({
                                        serviceSearchData: data,
                                        departmentType: data.module,
                                        serviceHeadCode: data.service_head_code,
                                        serviceHead: data.service_head,
                                        serviceName: data.service_name,
                                        serviceCode: data.service_code,
                                        editUnit: data.edit_unit,
                                        editAmount: data.edit_amount,
                                        editDiscount: data.edit_discount,
                                        activeByHead: data.active_by_service_name,
                                        activeByName: data.active_by_service_head,
                                        patientType: data.patient_type,
                                        selectedDoctorId: doctorList.find(doc => doc.doctor_id === data.doctor_id) || null,
                                        chargeType: data.charge_type,
                                        serviceCharge: data.service_charge,
                                        doctorShareRupee: data.doctor_share_amount,
                                        doctorSharePercent: data.doctor_share_percent.toFixed(2),
                                        hospitalShareRupee: data.hospital_share_amount,
                                        hospitalSharePercent: data.hospital_share_percent.toFixed(2),
                                        startTime: data.start_time ? dayjs(data.start_time, 'HH:mm:ss').format('hh:mm A') : null,
                                        endTime: data.end_time ? dayjs(data.end_time, 'HH:mm:ss').format('hh:mm A') : null
                                    });
                                    setTemp({
                                        serviceCharge: data.service_charge,
                                        doctorShareRupee: data.doctor_share_amount,
                                        doctorSharePercent: data.doctor_share_percent,
                                        hospitalShareRupee: data.hospital_share_amount,
                                        hospitalSharePercent: data.hospital_share_percent,
                                    })
                                    setIsActive(data?.is_active)
                                    setEditID(data)
                                }} />
                            </Stack>
                        </Stack>)
                }
            ] : [])
        ]
        return (
            <Box sx={{ height: '54vh', marginTop: '.5vw' }}>
                <DataGrid
                    checkboxSelection={commonDisable ? true : false}
                    selectionModel={CheckBoxList}
                    onRowSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={EmergHoliData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    // hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
                    sx={{
                        "& .gray-row .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
                            backgroundColor: "white !important",
                        }
                    }}
                    pagination
                    paginationMode="client"
                    headerHeight={40}
                    density='compact'
                    disableRowSelectionOnClick
                    pageSizeOptions={[10, 20, 30]}
                    paginationModel={{
                        page: page,
                        pageSize: pageSize
                    }}
                    onPaginationModelChange={(model) => {
                        setPage(model.page)
                        setPageSize(model.pageSize)
                    }}
                    rowCount={EmergHoliData.length}
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const clearFunction = () => {
        setFormState({
            serviceSearchData: null,
            departmentType: '',
            serviceHeadCode: '',
            serviceHead: '',
            serviceName: '',
            serviceCode: '',
            activeByHead: '',
            activeByName: '',
            editUnit: '',
            editAmount: '',
            editDiscount: '',
            selectedDoctorId: doctorList[0],
            chargeType: 'Holiday',
            serviceCharge: '',
            doctorShareRupee: '',
            doctorSharePercent: '',
            hospitalShareRupee: '',
            hospitalSharePercent: '',
        })
        setDisableDoctor(true)
        setserviceSearch('')
        setEditID(null)
        setIsActive(true);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }    

    const addHoliEmergDetails = (isAddCharges = false) => {
        try {
            if (!formState?.serviceSearchData || !formState?.serviceCharge || !formState?.chargeType || (formState?.chargeType === "Emergency" && (!formState?.startTime || !formState?.endTime))) {
                return errorMessage('Please Enter All mandatory fields')
            }

            if (formState?.serviceSearchData?.is_sharable === true ? !formState.doctorShareRupee && !formState.doctorSharePercent && !formState.hospitalShareRupee && !formState.hospitalSharePercent : '') {
                return errorMessage('Please Enter All mandatory fields')
            }

            if (
                formState?.startTime && 
                formState?.endTime &&
                dayjs(formState.startTime, 'hh:mm A').format('HH:mm:ss') === 
                dayjs(formState.endTime, 'hh:mm A').format('HH:mm:ss')
            ) {
                return errorMessage('Start time and end time should not be the same');
            }

            if (formState?.serviceSearchData?.is_sharable) {
                const serviceCharge = parseFloat(formState?.serviceCharge || 0);
                const doctorShare = parseFloat(formState?.doctorShareRupee || 0);
                const hospitalShare = parseFloat(formState?.hospitalShareRupee || 0);
            
                if (serviceCharge !== (doctorShare + hospitalShare)) {
                    return errorMessage('Service charge is not equal to the sum of doctor and hospital shares');
                }
            }             
            
            let data = {
                'patient_type': formState?.patientType,
                "active_by_service_head": formState?.activeByHead,
                "active_by_service_name": formState?.activeByName,
                "edit_unit": formState?.editUnit,
                "edit_amount": formState?.editAmount,
                "edit_discount": formState?.editDiscount,
                'patient_type': 'All',
                'unit': formState?.serviceSearchData?.unit,
                'unit_type': formState?.serviceSearchData?.unit_type,
                'is_active': isActive,
                "service_head_code": formState?.serviceHeadCode,
                "service_head": formState?.serviceHead,
                "service_code": formState?.serviceCode,
                "service_name": formState?.serviceName,
                "doctor_id": formState.selectedDoctorId?.id || null,
                "service_charge": formState?.serviceCharge ? Number(temp.serviceCharge) : 0,
                "doctor_share_percent": formState.doctorSharePercent ? Number(temp.doctorSharePercent) : 0,
                "hospital_share_percent": formState.hospitalSharePercent ? Number(temp.hospitalSharePercent) : 0,
                "doctor_share_amount": formState.doctorShareRupee ? Number(temp.doctorShareRupee) : 0,
                "hospital_share_amount": formState.hospitalShareRupee ? Number(temp.hospitalShareRupee) : 0,
                "charge_type": formState?.chargeType,
                'module_type': formState?.departmentType,
                'start_time': formState?.startTime ? dayjs(formState.startTime, 'hh:mm A').format('HH:mm:ss') : null,
                'end_time': formState?.endTime ? dayjs(formState.endTime, 'hh:mm A').format('HH:mm:ss') : null,
                'service_head_id': formState?.serviceSearchData?.service_head_id,
                'service_details_id': formState?.serviceSearchData?.service_details_id,
                'is_sharable' : formState?.serviceSearchData?.is_sharable ? formState?.serviceSearchData?.is_sharable : false,
                ...(EditID && { service_details_id: EditID?.service_details_id, service_head_id: EditID?.service_head_id, service_charge_id: EditID?.service_charge_id })
            }
            setisloader(true)
            RestAPIService.create(data, Serviceurls.NEW_DEPARTMENT_MASTER)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getHolidayEmergData()
                        const resetFormState = {
                            serviceCharge: '',
                            startTime: null,
                            endTime: null,
                            doctorShareRupee: '',
                            doctorSharePercent: '',
                            hospitalShareRupee: '',
                            hospitalSharePercent: '',
                            selectedDoctorId: formState?.selectedDoctorId || null, 
                            ...(isAddCharges ? {} :
                                {
                                    serviceSearchData: null,
                                    departmentType: '',
                                    serviceHeadCode: '',
                                    serviceHead: '',
                                    serviceName: '',
                                    serviceCode: '',
                                    activeByHead: '',
                                    activeByName: '',
                                    editUnit: '',
                                    editAmount: '',
                                    editDiscount: '',
                                    selectedDoctorId: null,
                                    chargeType: 'Holiday',
                                })
                        };
                        if (isAddCharges) {
                            setDisableDoctor(false);
                        } else {
                            setDisableDoctor(true) // temp work
                        }
                        // getDoctorList()
                        setIsActive(true)
                        setEditID(null)
                        setFormState({ ...formState, ...resetFormState });
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const DeleteHoliEmergData = () => {
        try {
            setisloader(true)
            let data = {
                "id": delIDs,
                "delete_by": "charge",
                "action_from": "holiday&emergency",
                "submit_action": "no",
            }
            RestAPIService.delete(`${Serviceurls.NEW_DEPARTMENT_MASTER}`, data)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        closeFilter();
                        getHolidayEmergData();
                        clearFunction()
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: '22.5vh', width: '93vw', backgroundColor: 'white', padding: '.6vw', }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                        {autoComplete("Search Service Code/Head*", 'serviceSearchData', formState?.serviceSearchData, searchList, '30.3vw')}
                        {textBox("Service Name*", 'serviceName', formState?.serviceName, '15vw', true)}
                        {textBox("Service Code", 'serviceCode', formState?.serviceCode, '15vw', true)}
                        {autoComplete("Doctor", 'selectedDoctorId', formState?.selectedDoctorId, doctorList, '15vw')}
                        {autoComplete("Charge Type*", 'chargeType', formState?.chargeType, charge_type_category, '15vw')}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex' }}>
                        {formState?.chargeType === 'Emergency' ? textBox("Emergency Charge*", 'serviceCharge', formState?.serviceCharge, '10.65vw') : textBox("Holiday Charge*", 'serviceCharge', formState?.serviceCharge, '15vw')}
                        {formState?.chargeType === 'Emergency' ?
                            <Box display="flex" alignItems="center" justifyContent="center">
                                <div>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimePicker
                                            label="Start Time*"
                                            value={formState.startTime ? dayjs(formState.startTime, 'hh:mm A') : null}
                                            onChange={(newValue) => {
                                                let value = newValue.format('hh:mm A');
                                                setFormState((prevState) => ({
                                                    ...prevState,
                                                    startTime: value,
                                                    endTime: value && prevState.endTime && dayjs(value).isAfter(dayjs(prevState.endTime)) ? null : prevState.endTime
                                                }));
                                            }}
                                            renderInput={(params) => <TextField {...params} inputProps={{ ...params.inputProps, readOnly: true }} size='small' style={{ width: "9.5vw", marginRight: "0.35vw", height: "2.5vw" }} />}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <div>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimePicker
                                            label="End Time*"
                                            value={formState.endTime ? dayjs(formState.endTime, 'hh:mm A') : null}
                                            onChange={(newValue) => {
                                                let value = newValue.format('hh:mm A');
                                                setFormState((prevState) => ({ ...prevState, endTime: value }))
                                            }}
                                            minTime={formState.startTime ? dayjs(formState.startTime , 'hh:mm A').add(1, 'minute') : null}
                                            disabled={!formState.startTime}
                                            renderInput={(params) => <TextField {...params} inputProps={{ ...params.inputProps, readOnly: true }} size='small' style={{ width: "9.5vw", marginRight: "0.35vw", height: "2.5vw" }} />}
                                        />
                                    </LocalizationProvider>
                                </div>
                            </Box>
                            : null}
                        {textBox(!formState?.serviceSearchData?.is_sharable === true ? "Doctor share" : "Doctor share*", 'doctorShareRupee', formState?.doctorShareRupee, '15vw', !formState?.serviceSearchData?.is_sharable === true ? true : false, 'rupee')}
                        {textBox(!formState?.serviceSearchData?.is_sharable === true ? "Doctor Percent" :"Doctor Percent*", 'doctorSharePercent', formState?.doctorSharePercent, '15vw', !formState?.serviceSearchData?.is_sharable === true ? true : false, 'percent')}
                        {textBox(!formState?.serviceSearchData?.is_sharable === true ? "Hospital share" :"Hospital share*", 'hospitalShareRupee', formState?.hospitalShareRupee, '15vw', !formState?.serviceSearchData?.is_sharable === true ? true : false, 'rupee')}
                        {textBox(!formState?.serviceSearchData?.is_sharable === true ? "Hospital Percent" :"Hospital Percent*", 'hospitalSharePercent', formState?.hospitalSharePercent, '15vw', !formState?.serviceSearchData?.is_sharable === true ? true : false, 'percent')}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex' }}>
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} size='small' disabled={!EditID} />} label={"Active"} />
                    </Box>
                    <Box sx={{ gap: '1vw', mr: "0.3vw", display: commonDisable ? null : 'none' }}>
                        { !EditID && formState?.chargeType === 'Emergency' && (
                            <Button
                                className='eMed_New_Ip_Btn'
                                startIcon={<AddCircle />}
                                sx={{ mr: "0.5vw" }}
                                onClick={() => { addHoliEmergDetails(true) }}
                            >
                                Add Additional Charge
                            </Button>
                        )}
                        <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw' }} onClick={() => { clearFunction() }}>Clear</Button>
                        <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '1vw' }} onClick={() => { addHoliEmergDetails(false) }}>{EditID ? 'Update' : 'Add'}</Button>
                    </Box>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '54vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to delete this item ?`}
                    DeleteNotify={"If you remove this, this could be effect in entire Configuration"}
                    deleteAlertPopupClose={closeFilter}
                    removeData={DeleteHoliEmergData}
                />
                : null}
            <Loader loaderOpen={isloader} />
        </Box>
    )
}